import { getBrowserTimeZone } from '@dashboard/junk-drawer/utils/time';
import moment from 'moment';
import { convertDateTimeToDate, usecToMs } from './datetime-converter';
/**
 * Formats a time range, e.g.: "5:00 - 7:00 pm", "11:00 pm - 2:00 am".
 *
 * The meridiem (am/pm) is only shown for the first time if it differs
 * from that of the second.
 */
export function formatTimeRange(startDateTime, endDateTime, localeTimeService) {
  const browserTimeZone = getBrowserTimeZone();
  const startMoment = moment.tz(usecToMs(startDateTime.instantUsec), browserTimeZone);
  const endMoment = moment.tz(usecToMs(endDateTime.instantUsec), browserTimeZone);
  const hideMeridiemForStart = localeTimeService.hideMeridiemForStart({
    startTime: startMoment,
    endTime: endMoment
  });
  return {
    formattedStart: localeTimeService.dateTime(startMoment, hideMeridiemForStart ? 'shortTimeWithoutMeridiem' : 'shortTime'),
    formattedEnd: localeTimeService.dateTime(endMoment, 'shortTime')
  };
}

/**
 * Formats a {@link DateTime} with date + time + meridiem + optional timezone.
 *
 * @returns Formatted date string, e.g. "Jun 25, 10:25 PM PT".
 */
export function formatDateTimeWithBrowserTimezone(dateTime, intl, showTimeZone) {
  // This will use the browser time zone
  const date = convertDateTimeToDate(dateTime);
  return {
    formattedDate: intl.formatDate(date, {
      // I tried adding this to `formats.js` but it wasn't working (intl was ignoring it, and using default formatting).
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: showTimeZone ? 'short' : undefined
    })
  };
}